import { MutationTree } from 'vuex';
import { State } from './state';

import { Vertrag, VertragAnalyse, VertragDokument, VertragItem } from '@/models/VertragModels';
import { PagedResult } from '@/models/CommonModels';

export enum MutationTypes {
  SetVertraege = 'SETVERTRAEGE',
  AddVertrag = 'ADDVERTRAG',
  AddOrUpdateVertrag = 'UPDATEVERTRAG',
  DeleteVertrag = 'DELETEVERTRAG',
  SetVertragPageData = 'SETVERTRAGPAGEDATA',

  SetVertragDokumente = 'SETVERTRAGDOKUMENTE',
  AddOrUpdateVertragDokument = 'UPDATEVERTRAGDOKUMENTE',
  DeleteVertragDokument = 'DELETEVERTRAGDOKUMENTE',

  SetVertragAnalysen = 'SETVERTRAGANALYSEN',
}

export type Mutations = {
  [MutationTypes.SetVertraege](state: State, data: Array<VertragItem>): void;
  [MutationTypes.AddVertrag](state: State, data: Vertrag): void;
  [MutationTypes.AddOrUpdateVertrag](state: State, data: Vertrag): void;
  [MutationTypes.DeleteVertrag](state: State, data: number): void;
  [MutationTypes.SetVertragPageData](state: State, data: PagedResult<VertragItem>): void;

  [MutationTypes.SetVertragDokumente](state: State, data: Array<VertragDokument>): void;
  [MutationTypes.AddOrUpdateVertragDokument](state: State, data: VertragDokument): void;
  [MutationTypes.DeleteVertragDokument](state: State, data: VertragDokument): void;

  [MutationTypes.SetVertragAnalysen](state: State, data: VertragAnalyse): void;
};

export const mutations: MutationTree<State> & Mutations = {
  //#region Vertraege
  [MutationTypes.SetVertraege](state: State, data: Array<VertragItem>) {
    state.vertragItems = data;
    localStorage.setItem('vertragItems', JSON.stringify(state.vertragItems));
  },

  [MutationTypes.AddVertrag](state: State, data: Vertrag) {
    state.vertraege.push(data);
    localStorage.setItem('vertraege', JSON.stringify(state.vertraege));

    const newItem = {
      id: data.id,
      titel: data.titel,
      type: data.type,
      personaldatenGuid: data.personaldatenGuid,
      adate: data.adate,
      vertragspartei1: data.vertragspartei1,
      vertragspartei2: data.vertragspartei2,
    } as VertragItem;

    state.vertragItems.push(newItem);
    localStorage.setItem('vertragItems', JSON.stringify(state.vertragItems));
  },

  [MutationTypes.AddOrUpdateVertrag](state: State, data: Vertrag) {
    var index = state.vertraege.findIndex((p) => p.id == data.id);
    if (index != -1) {
      state.vertraege.splice(index, 1, data);
    } else {
      state.vertraege.push(data);
    }

    localStorage.setItem('vertraege', JSON.stringify(state.vertraege));

    const newItem = {
      id: data.id,
      titel: data.titel,
      type: data.type,
      personaldatenGuid: data.personaldatenGuid,
      adate: data.adate,
      vertragspartei1: data.vertragspartei1,
      vertragspartei2: data.vertragspartei2,
    } as VertragItem;

    var itemIndex = state.vertragItems.findIndex((p) => p.id == data.id);
    if (itemIndex != -1) {
      state.vertragItems.splice(itemIndex, 1, newItem);
    } else {
      state.vertragItems.push(newItem);
    }

    localStorage.setItem('vertragItems', JSON.stringify(state.vertragItems));
  },

  [MutationTypes.SetVertragPageData](state: State, data: PagedResult<VertragItem>) {
    state.vertragPage = data;
  },

  [MutationTypes.DeleteVertrag](state: State, data: number) {
    var index = state.vertraege.findIndex((p) => p.id == data);
    if (index != -1) {
      state.vertraege.splice(index, 1);
    }

    localStorage.setItem('vertraege', JSON.stringify(state.vertraege));

    var itemIndex = state.vertragItems.findIndex((p) => p.id == data);
    if (itemIndex != -1) {
      state.vertragItems.splice(itemIndex, 1);
    }
  },
  //#endregion

  [MutationTypes.SetVertragDokumente](state: State, data: Array<VertragDokument>) {
    const vertragid = data[0].vertragid;
    const index = state.vertraege.findIndex((p) => p.id == vertragid);
    if (index != -1) {
      state.vertraege[index].vertragdokumente = data;
    }

    localStorage.setItem('vertraege', JSON.stringify(state.vertraege));
  },

  [MutationTypes.AddOrUpdateVertragDokument](state: State, data: VertragDokument) {
    const index = state.vertraege.findIndex((p) => p.id == data.vertragid);
    if (index != -1) {
      if (!state.vertraege[index].vertragdokumente) {
        state.vertraege[index].vertragdokumente = [];
      }

      const docIndex = state.vertraege[index].vertragdokumente.findIndex((p) => p.id == data.id);
      if (docIndex != -1) {
        state.vertraege[index].vertragdokumente.splice(docIndex, 1, data);
      } else {
        state.vertraege[index].vertragdokumente.push(data);
      }
    }

    localStorage.setItem('vertraege', JSON.stringify(state.vertraege));
  },

  [MutationTypes.DeleteVertragDokument](state: State, data: VertragDokument) {
    const index = state.vertraege.findIndex((p) => p.id == data.vertragid);
    if (index != -1) {
      const docIndex = state.vertraege[index].vertragdokumente.findIndex((p) => p.id == data.id);
      if (docIndex != -1) {
        state.vertraege[index].vertragdokumente.splice(docIndex, 1);
      }
    }

    localStorage.setItem('vertraege', JSON.stringify(state.vertraege));
  },

  //#region Analysen
  [MutationTypes.SetVertragAnalysen](state: State, data: VertragAnalyse) {
    state.vertragAnalysen = data;
  },
  //#endregion
};
